import React, { CSSProperties, ReactNode } from "react";
import ReactPlayer from "react-player";

type Props = {
  url?: string | null | undefined;
  playing?: boolean | null | undefined;
  loop?: boolean | null | undefined;
  controls?: boolean | null | undefined;
  light?: boolean | null | undefined;
  volume?: number | null | undefined;
  muted?: boolean | null | undefined;
  playbackRate?: number | null | undefined;
  width?: string | null | undefined;
  height?: string | null | undefined;
  style?: CSSProperties | null | undefined;
  progressInterval?: number | null | undefined;
  playsinline?: boolean | null | undefined;
  pip?: boolean | null | undefined;
  stopOnUnmount?: boolean | null | undefined;
  wrapper?: ReactNode | null | undefined;
  playIcon?: ReactNode | null | undefined;
  config?: unknown | null | undefined;
  className?: (string | string) | null | undefined;
  onPlay?: () => void | null | undefined;
};

function ReactPlayer1(__props: Props) {
  const url = __props["url"];
  const playing = __props["playing"];
  const loop = __props["loop"];
  const controls = __props["controls"];
  const light = __props["light"];
  const volume = __props["volume"];
  const muted = __props["muted"];
  const playbackRate = __props["playbackRate"];
  const width = __props["width"];
  const height = __props["height"];
  const style = __props["style"];
  const progressInterval = __props["progressInterval"];
  const playsinline = __props["playsinline"];
  const pip = __props["pip"];
  const stopOnUnmount = __props["stopOnUnmount"];
  const wrapper = __props["wrapper"];
  const playIcon = __props["playIcon"];
  const config = __props["config"];
  const className = __props["className"];
  const onPlay = __props["onPlay"];

  return /*#__PURE__*/ React.createElement(ReactPlayer, __props);
}

export default ReactPlayer1;
